import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Pin18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 3.75C7.48122 3.75 6.25 4.98122 6.25 6.5C6.25 8.01878 7.48122 9.25 9 9.25C10.5188 9.25 11.75 8.01878 11.75 6.5C11.75 4.98122 10.5188 3.75 9 3.75ZM7.75 6.5C7.75 5.80964 8.30964 5.25 9 5.25C9.69036 5.25 10.25 5.80964 10.25 6.5C10.25 7.19036 9.69036 7.75 9 7.75C8.30964 7.75 7.75 7.19036 7.75 6.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.19924 16.7283C8.27655 16.8166 9 17.6099 9 17.6099C9 17.6099 9.72345 16.8166 9.80076 16.7283C9.95534 16.5516 10.1749 16.296 10.4379 15.9773C10.9632 15.3406 11.6648 14.4477 12.368 13.4249C13.0697 12.4043 13.7826 11.2403 14.3224 10.0625C14.8574 8.89528 15.25 7.65587 15.25 6.5C15.25 3.08579 12.4142 0.25 9 0.25C5.58579 0.25 2.75 3.08579 2.75 6.5C2.75 7.65587 3.14261 8.89528 3.67758 10.0625C4.21742 11.2403 4.93028 12.4043 5.63197 13.4249C6.33517 14.4477 7.03684 15.3406 7.5621 15.9773C7.82506 16.296 8.04466 16.5516 8.19924 16.7283ZM4.25 6.5C4.25 3.91421 6.41421 1.75 9 1.75C11.5858 1.75 13.75 3.91421 13.75 6.5C13.75 7.34413 13.4551 8.35472 12.9588 9.43751C12.4674 10.5097 11.8053 11.5957 11.132 12.5751C10.4602 13.5523 9.78684 14.4094 9.28085 15.0227C9.18 15.145 9.08593 15.2573 9 15.3589C8.91407 15.2573 8.82 15.145 8.71915 15.0227C8.21316 14.4094 7.53983 13.5523 6.86803 12.5751C6.19472 11.5957 5.53258 10.5097 5.04117 9.43751C4.54489 8.35472 4.25 7.34413 4.25 6.5Z'
      fill='currentColor'
    />
  </Svg>
);

Pin18.displayName = 'Pin18';
export default Pin18;
